<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>分销管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="navFrame">
      <div class="navDataBig">
        <div v-for="v in navList" :key="v.id" @click="noteTem(v.id)">
          <div>{{v.title}}</div>
          <div>
            <span>
              <span>{{v.navTotal}}</span>
              <span>{{v.unit}}</span>
            </span>
            <img :src="v.srcUrl" alt />
          </div>
        </div>
      </div>
    </div>
    <el-card>
      <div class="searRow">
        <div class="searLeft">
          <el-input placeholder="分销商名称" v-model="data.name" clearable></el-input>
          <div class="searLeftSel">
            <el-select v-model="data.Status" placeholder="全部状态" clearable>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </div>
          <el-select v-model="data.ProID" placeholder="全部省份" clearable>
            <el-option
              v-for="item in province"
              :key="item.provinceCode"
              :label="item.provinceName"
              :value="item.provinceCode"
            ></el-option>
          </el-select>
          <el-button type="primary" @click="btns">查询</el-button>
        </div>
        <div class="searRight">
          <el-button type="primary" plain @click="addRetailFn()">
            <i class="iconfont icon-jiahao"></i>
            添加分销商
          </el-button>
        </div>
      </div>
      <div class="retail_table">
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column prop="nickname" label="排序" width="100">
              <template  slot-scope="scope">
                  <el-input class="sortChange" @change="sortChage(scope.row)" v-model="scope.row.sort"></el-input>
              </template>
          </el-table-column>
          <el-table-column prop="Name" label="分销商名称"></el-table-column>
          <el-table-column prop="address" label="分销商业务电话">
            <template slot-scope="scope">
              <span class="yewuPhone" v-if="scope.row.yewu_mobile">{{ scope.row.yewu_mobile }}（{{ scope.row.yewu_name }}）</span>
              <el-button type="text" @click="mobileFn(scope.row.DistrbutorID)" v-else>点击添加</el-button>
              <el-button type="text" @click="mobileFn(scope.row.DistrbutorID,scope.row.yewu_mobile,scope.row.yewu_name)"  v-if="scope.row.yewu_mobile">修改</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="Balance" label="余额"></el-table-column>
          <el-table-column prop="OverDraftMoney" label="可透支金额">
            <template slot-scope="scope">
              <div >
                <el-input 
                  v-model.number="scope.row.OverDraftMoney" 
                  type="number"
                  :min="0"
                  @input="handleOverDraftInput(scope.row)"
                  @change="handleClick(scope.row)"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="AlreadyOverdraft" label="已透支金额"></el-table-column>
          <el-table-column prop="address" label="操作" width="380"    fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="dataAuthorFn(scope.row)">期票授权</el-button>
              <el-button type="text" @click="caldarTctFn(scope.row)">日历票授权</el-button>
              <el-button type="text" @click="authorNumFn(scope.row)">授权数量修改</el-button>
              <el-button type="text" @click="RechargeFn(scope.row)">充值</el-button>
              <el-button type="text" @click="addRetailFn(scope.row)">详情</el-button>
              <el-button type="text" style="color: #FF4D4F;" @click="deteRetailFn(scope.row)">迁出</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="totla">排序规则遵循降序规则，数据按照从大到小的顺序排列，数据越大内容越往前，新填加的内容系统默认排序为0</span>
        <span class="demonstration">共{{count}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="count" @current-change="ListChange"></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 添加分销商开始 -->
    <addRetail v-if="addRetailvisible" ref="addRetailDialog" :OverDraftMoney="OverDraftMoney" :addRetailvisibleId="addRetailvisibleId" @defail="addRetailClose"></addRetail>
    <!-- 添加分销商结束 -->
    <!-- 日历开始 -->
    <caldarTctDialog v-if="caldarTctvisible" ref="caldarTctDialog" :caldarId="caldarId" @defailClose="defailClose"></caldarTctDialog>
    <!-- 日历结束 -->
    <!-- 期票授权修改开始 -->
    <dataAuthorDialog v-if="dataAuthorvisible" ref="dataAuthorDialog" :AuthorizableId="AuthorizableId" @AuthoClose="AuthoClose"></dataAuthorDialog>
    <!-- 期票授权修改结束 -->

    <!-- 联系人添加弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="mobilTitle"
      :visible.sync="mobileDialogVisible"
      :before-close="mobileHandleClose"
      width="24.0%"
      center
      top="30vh"
    >
      <el-divider></el-divider>

      <el-form ref="form" :model="form" :rules="rules" label-width="85px">
        <div class="formItem">
          <el-form-item label="姓名:" prop="yewu_name">
            <el-input v-model="form.yewu_name" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系电话:" prop="yewu_mobile">
            <el-input v-model="form.yewu_mobile" placeholder="请输入联系人电话"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="flexbtnL">
        <div class="flexbtnL_clear" @click="clearPry">清空</div>
        <el-button class="btnL"  type="primary" @click="select('form')">确认添加</el-button>
      </div>
    </el-dialog>
    <!-- 联系人添加弹框结束 -->
    <!-- 充值弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="充值"
      :visible.sync="RechargeDialogVisible"
      :before-close="RechargeHandleClose"
      width="38.6%"
      center
      top="30vh"
    >
      <el-divider></el-divider>
      <div class="RechargeContent">
        <el-form ref="formRe" :model="formRe" label-width="75px">
          <div class="RechargeItem">
            <el-form-item label="当前余额:">
              <el-input v-model="formRe.Balance" placeholder="请输入当前余额" disabled></el-input>
            </el-form-item>
            <el-form-item label="充值金额:">
              <el-input 
                v-model.number="formRe.money" 
                type="number"
                :min="0"
                placeholder="请输入充值金额"
                @input="handleMoneyInput"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input v-model="formRe.remark" placeholder="请输入备注"></el-input>
            </el-form-item>
            <el-form-item class="itemBtnS" >
              <el-button @click="chargeCli">充值</el-button>
            </el-form-item>
          </div>
        </el-form>
        <div>
          <el-table
            :data="RecordArr"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            style="width: 100%"
          >
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column prop="PayTime" label="充值时间" width="180"></el-table-column>
            <el-table-column prop="Pay" label="充值金额"></el-table-column>
            <el-table-column  label="充值前金额">
               <template slot-scope="scope">
                 <span>{{ scope.row.Balance-scope.row.Pay }}</span>
               </template>
            </el-table-column>
            <el-table-column prop="Balance" label="余额"></el-table-column>
            <el-table-column prop="UserName" label="操作人"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>

          </el-table>
        </div>
        <!-- 分页开始 -->
        <div class="pagination">
          <!-- <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data1.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total" @current-change="ListArr"></el-pagination> -->
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data1.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data1.page_size" :total="total" :current-page="data1.page"  @current-change="ListArr"></el-pagination>  
        </div>
      </div>
      <!-- 分页结束 -->
    </el-dialog>
    <!-- 充值弹框结束 -->
    <!-- 授权数量修改弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="授权数量修改"
      :visible.sync="authorDialogVisible"
      :before-close="authorHandleClose"
      width="75.9%"
      center
      top="30vh"
    >
      <el-divider></el-divider>

      <div class="authorTable">
        <el-table
          :data="tableData1"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column prop="ProductName" label="产品名称"></el-table-column>
          <el-table-column prop="ProductID" label="产品ID"></el-table-column>
          <el-table-column prop="address" label="每日限购数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.DayNumber" @blur="Astrict(scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="总限购数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.AllNumber" @blur="Astrict(scope.row)"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{total2}}条记录，</span>
          <span class="demonstration">当前显示第{{data2.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data2.page_size" :total="total2" :current-page="data2.page"  @current-change="ListArr2" ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 授权数量修改弹框结束 -->
  </div>
</template>

<script>
import addRetail from "./dialog/addRetail.vue";
import caldarTctDialog from "./dialog/caldarTctDialog.vue";
import dataAuthorDialog from "./dialog/dataAuthorDialog.vue";
import cityOptions from "@/assets/city.json";
import {MessageBox,Message} from 'element-ui'
import {SetDayAstrict,ProductAndDistributorList,SeniceStatisticalData,getScenicListDistrbutor,
  DisSetPhone,ScenicRechargeRecord,rechargeScenic,ScenicDisSave,
  GetTermBill,
  changeSort} from '@/request/scenic.js'
export default {
  components: {
    addRetail,
    caldarTctDialog,
    dataAuthorDialog
  },
  data() {
    return {
      options: [
        {
          value: "1",
          label: "正常"
        },
        {
          value: "2",
          label: "停用"
        }
      ],
      value: "",
      value3: "",
      tableData: [
      ],
      form: {
        yewu_name: "",
        yewu_mobile:''
      },
      rules:{
        yewu_name:[{ required: true, message: '请输入业务员名称', trigger: 'blur' }],
        yewu_mobile:[{ required: true, message: '请输入业务员手机号', trigger: 'blur' }],
      },
      input: "",
      mobileDialogVisible: false, // 订单详情
      addRetailvisible: false, // 添加分销商详情
      RechargeDialogVisible: false, // 充值
      authorDialogVisible: false, // 授权数量修改
      caldarTctvisible: false, // 日历票授权
      dataAuthorvisible: false, // 期票授权
      mobilTitle: "", // 联系人添加修改
      navList: [
        {
          id: 1,
          title: "分销商开通总数",
          navTotal: 0,
          srcUrl: require("@/images/scenic/kt.png"),
          unit: "家"
        },
        {
          id: 2,
          title: "我接入的分销商",
          navTotal: 0,
          srcUrl: require("@/images/scenic/jr.png"),
          unit: "家"
        },
        {
          id: 3,
          title: "共享系统分销商",
          navTotal: 0,
          srcUrl: require("@/images/scenic/gx.png"),
          unit: "家"
        },
        {
          id: 4,
          title: "分销商库总数",
          navTotal: 0,
          srcUrl: require("@/images/scenic/k.png"),
          unit: "家"
        }
      ],
      data:{
        token:window.sessionStorage.getItem('Token'),
        name:'',
        ProID:'',
        Status:'',
        page:1,
        page_size:10
      },
      count:0,
      addRetailvisibleId:'',
      yewu_mobile:'',
      DistrbutorID:'',
      AuthorizableId:'',
      caldarId:'',
      province:[],
      data1:{
        token:window.sessionStorage.getItem('Token'),
        distrbutorid:'',
        page:1,
        page_size:6
      },
      total:0,
      RecordArr:[],
      formRe:{
        Balance:'',
        money:'',
        remark:''
      },
      tableData1:[],
      data2:{
        page:1,
        page_size:5,
        token:window.sessionStorage.getItem('Token'),
        DistributorID:''
      },
      total2:0,
      flowCli:false,
      OverDraftMoney:''
    };
  },
  created(){
    this.province =  cityOptions
    this.getList() //景区下获取分销商
    this.sticalData() // 分销商统计
  },
  methods: {
    handleOverDraftInput(row) {
      // 确保输入值不能为负数
      if (row.OverDraftMoney < 0 || row.OverDraftMoney === null || row.OverDraftMoney === undefined) {
        row.OverDraftMoney = 0;
      }
      // 如果是字符串，转换为数字
      if (typeof row.OverDraftMoney === 'string') {
        const num = parseFloat(row.OverDraftMoney);
        if (isNaN(num) || num < 0) {
          row.OverDraftMoney = 0;
        } else {
          row.OverDraftMoney = num;
        }
      }
    },
    handleMoneyInput() {
      // 确保输入值不能为负数
      if (this.formRe.money < 0 || this.formRe.money === null || this.formRe.money === undefined) {
        this.formRe.money = 0;
      }
      // 如果是字符串，转换为数字
      if (typeof this.formRe.money === 'string') {
        const num = parseFloat(this.formRe.money);
        if (isNaN(num) || num < 0) {
          this.formRe.money = 0;
        } else {
          this.formRe.money = num;
        }
      }
    },
    handleClick(item){
      // if(item.yewu_mobile==''){
      //   this.$message.error('请先添加业务员电话')
      //   return false
      // }
      if(item.OverDraftMoney<0){
        this.$message.error('透支金额必须大于等于0')
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        phone:item.yewu_mobile,
        name:item.Name,
        Disid:item.DistrbutorID,
        OverDraftMoney:item.OverDraftMoney
      }
      DisSetPhone(data).then(res=>{
        if(res.data.rcode==200){
          Message.success('修改透支金额成功')
          this.getList()
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    sortChage(item){
        if(item.sort<0){
          this.$message.error('请输入大于0的整数')
          return false
        }else{
          let num = /^[0-9]*$/.test(item.sort)
          if(num){
          }else{
            this.$message.error('请输入整数')
            return false
          }
        }
        let data = {
          token:window.sessionStorage.getItem('Token'),
          sort:item.sort,
          ScenicDistrbutorID:item.DistrbutorID
        }
        changeSort(data).then(res=>{
          if(res.data.rcode==200){
            this.getList() //景区下获取分销商
            this.sticalData() // 分销商统计
            this.$message.success('排序成功')
          }
        })
        
      },
    // 清空联系人
    clearPry(){
      this.form={
        yewu_name: "",
        yewu_mobile:''
      }
    },
    // 授权数量修改 输入框监听
    Astrict(row){
      if(row.a == row.DayNumber&&row.b == row.AllNumber){
        return false
      }
      if(row.AllNumber<0){
        Message.error('总限购数量不能小于0')
        return false
      }
      if(row.DayNumber<0){
        Message.error('每日限购数量不能小于0')
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        DayNum:row.DayNumber,
        AllNumber:row.AllNumber,
        ProductID:row.ProductID,
        DistributorID:this.data2.DistributorID,
      }
      SetDayAstrict(data).then(res=>{
        if(res.data.status=='ok'){
          Message.success('修改成功')
          row.a = row.DayNumber
          row.b = row.AllNumber
        }else{
          Message.error(res.data.msg)
          this.tableData1.map(item=>{
            if(item.ProductID==row.ProductID){
              row.DayNumber = row.a
              row.AllNumber = row.b
            }
          })
        }
      })
    },
    //分页
    ListArr(e){
      this.data1.page = e
      this.RecordList()
    },
    // 充值
    chargeCli(){
      if(this.flowCli){
        return false
      }
      if(this.formRe.money < 0){
        Message.error('充值金额不能小于0')
        return false
      }
      if(this.formRe.money>1000000){
        Message.error('充值金额不能大于一百万')
        return false
      }
      this.flowCli = true
      let data = {
        distrbutorid:this.data1.distrbutorid,
        token:window.sessionStorage.getItem('Token'),
        money: this.formRe.money,
        remark:this.formRe.remark
      }
      rechargeScenic(data).then(res=>{
          if(res.data.status=='ok'){
            Message.success('充值成功')
            this.RechargeDialogVisible = false;
            this.formRe.Balance = ''
            this.formRe.money=''
            this.formRe.remark = ''
            this.getList()
            this.flowCli = false
          }else{
            Message.error(res.data.msg)
            this.flowCli = false
          }
      })
    },
    // 充值记录
    RecordList(){
      ScenicRechargeRecord(this.data1).then(res=>{
        if(res.data.rcode==200){
          this.RecordArr = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },
    // 删除
    deteRetailFn(row){
      MessageBox('此操作将迁出该分销商, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let data = {
              token:window.sessionStorage.getItem('Token'),
              Status:'2',
              DistrbutorID:row.DistrbutorID
            }
            ScenicDisSave(data).then(res=>{
              if(res.data.status=='yes'){
                this.getList()
                Message.success('删除成功')
              }
            })
        }).catch(() => {
                 
        });
    },
    // 查询
    btns(){
      this.data.page = 1
      this.getList()
    },
    // 修改添加业务员
    select(form){
      this.$refs['form'].validate((valid)=>{
        if(valid){
          let data = {
            phone:this.form.yewu_mobile,
            name:this.form.yewu_name,
            token:window.sessionStorage.getItem('Token'),
            Disid:this.DistrbutorID
          }
          DisSetPhone(data).then(res=>{

            if(res.data.rcode==200){
              this.getList()
              Message.success('业务员信息编辑成功')
              this.mobileDialogVisible = false;
              this.form.yewu_mobile = ''
              this.form.yewu_name = ''
              this.DistrbutorID = ''
            }else{
              Message.success(res.data.msg)
            }
          })
        }else{

        }
      })
    },
    // 分页
    ListChange(e){
      this.data.page = e
      this.getList()
    },
    getList(){
      getScenicListDistrbutor(this.data).then(res=>{
        if(res.data.rcode==200){
          this.tableData = res.data.result.data
          this.count = res.data.result.total
          this.tableData.map(item=>{
            item.dis = true
          })
        }
      })
    },
    sticalData(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      SeniceStatisticalData(data).then(res=>{
        if(res.data.rcode ==200){
              this.navList[0].navTotal = res.data.result.sceKTCount
              this.navList[1].navTotal = res.data.result.sceJRCount
              this.navList[3].navTotal = res.data.result.disCount
              this.navList[2].navTotal = res.data.result.shareCount
        }
      })
    },
    // 期票授权
    dataAuthorFn(row) {
      this.AuthorizableId = row.DistrbutorID
      this.dataAuthorvisible = true;
      this.$nextTick(() => {
        this.$refs.dataAuthorDialog.dataAuthor(row);
      });
    },
    // 期票授权关闭
    AuthoClose(){
      this.AuthorizableId =''
      this.dataAuthorvisible = false;
    },
    // 日历票授权
    caldarTctFn(row) {
      this.caldarId = row.DistrbutorID
      this.caldarTctvisible = true;
      this.$nextTick(() => {
        this.$refs.caldarTctDialog.caldarTct(row);
      });
    },
    // 日历票授权关闭
    defailClose(){
      this.getList() //景区下获取分销商
      this.caldarId = ''
      this.caldarTctvisible = false;
    },
    // 授权数量修改
    authorNumFn(row) {
      this.data2.DistributorID = row.DistrbutorID
      this.authorDialogVisible = true;
      let data = {
        token:window.sessionStorage.getItem('Token'),
        disid:row.DistrbutorID
      }
      GetTermBill(data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData1 =res.data.result
          this.tableData1.map(item=>{
            item.a = item.DayNumber
            item.b = item.AllNumber
          })
        }
      })
    },
    //授权数量修改分页
    ListArr2(e){
      this.data2.page = e
      ProductAndDistributorList(this.data2).then(res=>{
        if(res.data.status=='ok'){
          this.tableData1 =res.data.result.data
          this.total2 = res.data.result.total
        }
      })
    },
    // 授权数量修改X
    authorHandleClose() {
      this.authorDialogVisible = false;
      this.tableData1 = []
    },
    // 点击充值
    RechargeFn(row) {
      this.formRe.Balance = row.Balance
      this.data1.distrbutorid = row.DistrbutorID
      this.RecordList()
      this.RechargeDialogVisible = true;
    },
    // 点击充值X
    RechargeHandleClose() {
      this.RechargeDialogVisible = false;
      this.formRe.Balance = ''
      this.formRe.money=''
      this.formRe.remark = ''
    },
    // 联系人添加
    mobileFn(DistrbutorID,row,name) {
      this.DistrbutorID = DistrbutorID
      if (row) {
        this.mobilTitle = "修改联系人";
        this.form.yewu_mobile = row
        this.form.yewu_name = name
      } else {
        this.mobilTitle = "点击添加";
      }
      this.mobileDialogVisible = true;
    },
    // 联系人添加X
    mobileHandleClose() {
      this.mobileDialogVisible = false;
      this.form.yewu_mobile = ''
      this.form.yewu_name = ''
    },
    // 添加分销商
    addRetailFn(row) {
      this.addRetailvisible = true;
      if(row){
        this.addRetailvisibleId = row.DistrbutorID
        this.OverDraftMoney = row.OverDraftMoney
      }else{
        this.addRetailvisibleId = ''
      }
      this.$nextTick(() => {
        this.$refs.addRetailDialog.addRetail(row);
      });
    },
    addRetailClose(){
      this.getList()
      this.addRetailvisible = false
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.authorTable {
  .el-input {
    width: 100px;
    height: 30px;
  }
  /deep/.el-input__inner {
    -webkit-appearance: none;
    background: #f7f7fa;
    border-radius: 4px;
    border: none;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 30px;
    line-height: 30px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
    text-align: center;
  }
  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    position: relative;
    align-items: center;
    height: 32px;
    margin: 20px auto 0px;
  }
}
.RechargeContent {
  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    height: 32px;
    margin: 20px auto 0px;
  }
  .RechargeItem {
    display: flex;
    flex-wrap: wrap;
    .el-form-item {
      margin-right: 20px;
    }
    .el-input {
      // width: 200px;
    }
    .itemBtnS {
      .el-button {
        width: 100px;
        background: #246deb;
        border-radius: 4px;
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        text-align: center;
        color: #ffffff;
        border: none;
        margin-left: -75px;
      }
    }
  }
}
.searRow {
  display: flex;
  justify-content: space-between;
  flex-wrap:wrap ;
  margin-bottom: 20px;
  .searLeft {
    display: flex;
    flex-wrap: wrap;
    .el-input {
      width: 240px;
      margin-bottom: 1rem;
      margin-right: 10px;
    }
    .searLeftSel {
      // margin-bottom: 1rem;
      margin-right: 10px;
    }
    .el-select {
      width: 260px;
      margin-bottom: 1rem;
      margin-right: 10px;
    }
  }
  .el-button {
    height: 4rem;
    width: 136px;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #246deb;
  }
}
.btn {
  display: flex;
  justify-content: center;
  margin: 40px 0 30px 0;
  /deep/.el-button {
    width: 100px;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
    background: #ffffff;
  }
}
.conentCenter {
  .printImg {
    display: flex;
    justify-content: center;
    position: relative;
  }
  .printContent {
    width: 400px;
    //   height: 492px;
    padding: 0 20px;
    box-sizing: border-box;
    margin: auto;
    // border: 1px double #246deb;
    position: absolute;
    top: 82px;
    left: 41px;
    > div:nth-child(1) {
      height: 64px;
      line-height: 64px;
      text-align: center;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      /* identical to box height */
      color: #000000;
      border-bottom: 2px double #c4c4c4;
    }
    > div:nth-child(2) {
      margin-top: 18px;
      /deep/.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
        padding-bottom: 15px;
      }
      /deep/.el-descriptions-item__label {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        text-align: right;

        color: #666666;
      }
      /deep/.el-descriptions-item__content {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;

        color: #000000;
      }
    }
    > div:nth-child(3) {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #e74c3c;
      margin: 10px 0 20px 0;
    }
  }
}
.btns {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  .el-button {
    width: 100px;
    height: 40px;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;

    color: #246deb;
  }
  .btnL {
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;

    color: #ffffff;
  }
}
.formItem {
  .el-input {
    width: 300px;
  }
  .itemBtnS {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-left: -75px;
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
}

.navFrame {
  width: 100%;
  display: flex;
  margin: 17px 0;
  .navDataBig {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    > div {
      min-width: 280px;
      margin-bottom: 1rem;
      width: 24%;
      height: 150px;
      background: #ffffff;
      border-radius: 4px;
      margin-right: 15px;
      > div:nth-child(1) {
        height: 20px;
        margin-left: 20px;
        margin-top: 17px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */

        color: #666666;
      }
      > div:nth-child(2) {
        height: 56px;
        display: flex;
        margin-top: 40px;
        // background: red;
        img {
          width: 80px;
          height: 60px;
          margin-right: 20px;
        }
        span {
          width: 100%;
          height: 100px;
          margin-bottom: 20px;
          display: flex;
          > span:nth-child(1) {
            display: block;
            width: 120px;
            height: 100%;
            line-height: 100px;
            margin-left: 21px;
            margin-right: 8px;
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 600;
            font-size: 40px;
            line-height: 56px;
            /* identical to box height */
            color: #246deb;
          }
          > span:nth-child(2) {
            display: block;
            width: 20px;
            height: 100%;
            margin-top: 20px;
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
            /* identical to box height */
            color: #797979;
          }
        }
      }
    }
  }
}
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}
/deep/.el-dialog__headerbtn {
  position: absolute;
  top: 0px;
  right: 20px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
.yewuPhone{
 margin-right: 1rem;
}
.flexbtnL{
  display: flex;
  justify-content: center;
  .flexbtnL_clear{
    width: 10rem;
    height: 4rem;
    background: #D9D9D9;
    color: #ffffff;
    border-radius: 0.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 2rem;
    cursor: pointer;
  }
}
/deep/ .el-dialog{
  min-width: 300px;
}
.retail_table /deep/ .el-table th,.retail_table /deep/.el-table td{
  text-align:left !important;
}
.totla{
  position: absolute;
  left: 2rem;
  width: 35rem;
  color: red !important;
}

</style>